import React from 'react'
import styles from './Vision.module.css'

const InsightsPanel = ({ title = 'AI Analysis Insights', insights }) => {
    if (!insights || !insights.length) return null
    return (
        <div className={styles.insights}>
            <h4 className={styles.insightsTitle}>{title}</h4>
            <div className={styles.insightsList}>
                {insights.map((row, i) => (
                    <div key={i} className={styles.insightRow}>
                        <span className={styles.insightLabel}>{row.label}:</span>
                        {row.swatch ? (
                            <span
                                className={styles.swatch}
                                style={{ background: row.swatch }}
                            />
                        ) : (
                            <span className={styles.insightValue}>{row.value}</span>
                        )}
                    </div>
                ))}
            </div>
        </div>
    )
}

export default InsightsPanel
